const BASE = "https://creationarts.com";

export const seoConfig: Record<
  string,
  { titleKey: string; descriptionKey: string; path: string }
> = {
  "custom-flags": {
    titleKey: "seo:flags:title",
    descriptionKey: "seo:flags:description",
    path: "/services/custom-flags",
  },
  flagpoles: {
    titleKey: "seo:flagpoles:title",
    descriptionKey: "seo:flagpoles:description",
    path: "/services/flagpoles",
  },
  banners: {
    titleKey: "seo:banners:title",
    descriptionKey: "seo:banners:description",
    path: "/services/banners",
  },
  badges: {
    titleKey: "seo:badges:title",
    descriptionKey: "seo:badges:description",
    path: "/services/badges",
  },
  sticker: {
    titleKey: "seo:sticker:title",
    descriptionKey: "seo:sticker:description",
    path: "/services/sticker",
  },
  lanyards: {
    titleKey: "seo:lanyards:title",
    descriptionKey: "seo:lanyards:description",
    path: "/services/lanyards",
  },
  apparel: {
    titleKey: "seo:apparel:title",
    descriptionKey: "seo:apparel:description",
    path: "/services/apparel",
  },
};

export const buildSchema = (
  title: string,
  description: string,
  canonical: string,
  lang: string,
  faqItems?: Array<{ q: string; a: string }>,
): object[] => {
  const schemas: object[] = [];

  const homeUrl = `${BASE}/${lang}`;
  const servicesUrl = `${BASE}/${lang}/services`;

  schemas.push({
    "@context": "https://schema.org",
    "@type": "Service",
    name: title.split(" | ")[0],
    description: description,
    url: canonical,
    provider: {
      "@type": "Organization",
      name: "Creation Arts For Flags and Digital Printing LLC",
      url: BASE,
      address: {
        "@type": "PostalAddress",
        addressLocality: "Abu Dhabi",
        addressCountry: "AE",
      },
    },
    areaServed: {
      "@type": "Place",
      name: "Worldwide",
    },
  });

  schemas.push({
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: lang === "ar" ? "الرئيسية" : "Home",
        item: homeUrl,
      },
      {
        "@type": "ListItem",
        position: 2,
        name: lang === "ar" ? "الخدمات" : "Services",
        item: servicesUrl,
      },
      {
        "@type": "ListItem",
        position: 3,
        name: title,
        item: canonical,
      },
    ],
  });

  if (faqItems && faqItems.length > 0) {
    schemas.push({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqItems.map((item) => ({
        "@type": "Question",
        name: item.q,
        acceptedAnswer: {
          "@type": "Answer",
          text: item.a,
        },
      })),
    });
  }

  return schemas;
};

/** BreadcrumbList JSON-LD. `path` is without the /:lang prefix ("" = home). */
export const breadcrumbSchema = (
  lang: string,
  crumbs: { name: string; path: string }[],
) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: crumbs.map((c, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: c.name,
    item: `${BASE}/${lang}${c.path}`,
  })),
});
